import React, { useState, useEffect } from "react";
import { getImageBlob } from "../apis";

// 1x1 transparent gif. react-image-lightbox's mainSrc/nextSrc/prevSrc are
// required string props on that third-party component, so this fills them in
// only until the real authenticated fetch resolves — never used for actual
// image content.
export const BLANK_IMAGE_PLACEHOLDER =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBTAA7";

// Renders an image that lives behind an authenticated endpoint (qna-service /
// chat-service "images?path=..." routes) instead of a public URL. Fetches the
// blob via the shared axios instance (which attaches x-user-token) and
// converts it to an object URL. Renders nothing at all — no <img> element in
// the DOM — until the fetch resolves, so there's no browser broken-image
// icon/alt-text glyph while loading (that glyph shows for any <img> with no
// resolved src once the element has a visible CSS box, not just on a failed
// request); also renders nothing on failure.
const AuthenticatedImage = ({
  relativePath,
  apiEndpoint,
  style,
  alt,
  onClick,
  imgKey,
}) => {
  const [objectUrl, setObjectUrl] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!relativePath || !apiEndpoint) {
      return undefined;
    }
    let cancelled = false;
    let createdUrl = null;
    setHasError(false);
    setObjectUrl(null);
    getImageBlob(relativePath, apiEndpoint)
      .then((blob) => {
        if (cancelled) return;
        createdUrl = URL.createObjectURL(blob);
        setObjectUrl(createdUrl);
      })
      .catch((error) => {
        console.error("Failed to load image", relativePath, error);
        if (!cancelled) setHasError(true);
      });

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [relativePath, apiEndpoint]);

  if (hasError || !objectUrl) {
    return null;
  }

  return (
    <img
      style={style}
      key={imgKey}
      src={objectUrl}
      alt={alt}
      onClick={onClick}
    />
  );
};

export default AuthenticatedImage;
